<template>
  <omint-page>
    <Header
      name="Credencial"
      titleLabel="Credencial"
    />
    <omint-page-content>
      <Credential
        :id="c.id"
        :number="c.number"
        :name="c.name"
        :ingress="c.ingress"
        :valid="c.valid"
        :birth="c.birth"
        :plan="c.plan"
        :bg="credentialBackground(c)"
        :credType="c.credType"
        :cns="c.cns"
        :numberT="c.numberT"
        :planT="c.planT"
        :accT="c.accT"
        :accTp="c.accTp"
        :idx="null"
        @token="tokenUpdated"
      />
    </omint-page-content>
  </omint-page>
</template>

<script>
import Credential from "@/components/Organisms/Credential.vue";
import Header from "@/components/Molecules/Header";
import { mapState, mapGetters } from "vuex";
import Footer from "@/components/Molecules/Footer";

export default {
  name: "FullCredential",
  components: { Credential, Header, Footer },
  props: ["idx"],
  computed: {
    ...mapState("saude", ["credentials"]),
    ...mapGetters("saude", ["credentialBackground"]),
    c() {
      if (this.credentials && this.credentials.length - 1 >= this.idx) {
        return this.credentials[Number(this.idx)];
      }
      return {};
    }
  },
  mounted() {
    this.$root.$emit("hide-loading");
    if (!this.credentials || this.credentials.length === 0) {
      this.$router.push("/");
    }
  },
  methods: {
    tokenUpdated(token) {
      const credential = this.c;
      if (credential && credential.isMdSv === true) {
        this.$root.$emit("change-title-label", "Credencial Mediservice");
      } else {
        this.$root.$emit("change-title-label", `Credencial Token ${token}`);
      }
    }
  }
};
</script>
